import { CircularProgress } from "@mui/joy";

export function LoadingComponent() {
    return (
        <div className="flex justify-center items-center h-36">
            <CircularProgress />
        </div>
    )
}